
import Hero from "../Components/SecondComponents/Hero";
import HeartDisease from "../Components/SecondComponents/HeartDisease";
import MythsFacts from "../Components/SecondComponents/Myths&Facts";
import Subscribe from "../Components/FirstComponents/Subscribe";

function SecondLanding() {
  return (
    <>
      <div
        className="bg-gray-200 bg-no-repeat bg-contain "
        style={{
          backgroundImage: "url('/assets/background.png')",
          backgroundPosition: "right top",
        }}
      >
        <div className="mx-auto ">
          <Hero />
          <HeartDisease />
          <MythsFacts />
          <Subscribe />
        </div>
      </div>
    </>
  );
}

export default SecondLanding;
